import { Relation } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import {
  phoneValidation,
  requiredDialCode,
  requiredEmail,
  requiredPhoneNumber,
  requiredString,
} from '@/utils/zodUtils';

export const BorrowerInvitationFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      fullName: requiredString(t),
      documentNumber: z.string().optional().nullable(),
      email: requiredEmail(t).nullable(),
      phoneNumber: requiredPhoneNumber(t),
      dialCode: requiredDialCode(t),
      relation: z.nativeEnum(Relation).optional().nullable(),
      expiresOn: z.date().optional().nullable(),
    })
    .refine((data) => !(data.phoneNumber && data.dialCode && !phoneValidation(data)), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    });

export type BorrowerInvitationFormType = z.infer<ReturnType<typeof BorrowerInvitationFormSchema>>;
